module.exports = "/static/assets/47388a326a01718897c15862b0f182a4.png";